import { Skeleton } from '@mui/material';

import gStyles from '@/Global.module.css';
import styles from './OrderHeader.module.css';

/**
 * Modal sub-header to display Dispatch Order Information
 */
export default function LegOrderHeaderSkeleton() {
	return (
		<div className={`${styles.header} ${styles['leg-header']}`}>
			<span className={`${gStyles['label']} ${styles['order-lbl']}`}>Order #</span>
			<div className={styles.order}>
				<Skeleton
					variant='rounded'
					height={25}
					width={100}
				/>
			</div>

			<span className={`${gStyles['label']} ${styles['customer-ref-lbl']}`}>Customer Ref #</span>
			<Skeleton
				variant='rounded'
				height={25}
				width={100}
				className={`${gStyles.bold} ${styles['customer-ref']}`}
			/>

			<span className={`${gStyles['label']} ${styles['job-cat-lbl']}`}>Job Category</span>
			<Skeleton
				variant='rounded'
				height={25}
				width={100}
				className={`${gStyles.bold} ${styles['customer-ref']}`}
			/>

			<div className={styles['tag-group']}>
				<div className={styles.tag}>
					<Skeleton
						variant='rounded'
						height={18}
					/>
				</div>
				<div className={styles.tag}>
					<Skeleton
						variant='rounded'
						height={18}
					/>
				</div>
				<div className={styles.tag}>
					<Skeleton
						variant='rounded'
						height={18}
					/>
				</div>
				<div className={styles.tag}>
					<Skeleton
						variant='rounded'
						height={18}
					/>
				</div>
			</div>

			<span className={`${gStyles['label']} ${styles['leg-label']}`}>Leg</span>

			<Skeleton
				variant='rounded'
				className={`${styles['leg']} ${gStyles.bold}`}
				height={25}
			/>

			<span className={`${gStyles['label']} ${styles['status-lbl']}`}>Status</span>
			<Skeleton
				variant='rounded'
				className={styles.status}
				width={100}
				height={25}
			/>

			<span className={`${gStyles['label']} ${styles['assigned-lbl']}`}>Assigned</span>
			<Skeleton
				variant='rounded'
				className={`${styles.assigned} ${gStyles.bold}`}
				height={25}
			/>

			<span className={`${gStyles['label']} ${styles['tractor-lbl']}`}>Truck</span>
			<Skeleton
				variant='rounded'
				className={`${styles.tractor} ${styles.bold}`}
				height={25}
			/>
		</div>
	);
}
